<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Admissions: Direct Second Year Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Direct Second Year Engineering'}]"></page-header>
      <div class="container-2 gap-4">
        <section class="content">
          <accordion :activeIndex="0">
            <accordion-tab header="Sanction Intake">
              <sanction-intake class="w-full" :programmes="programmes"></sanction-intake>
            </accordion-tab>
            <accordion-tab header="Important Notifications">
              <TabView>
                <TabPanel header="Information Brochure">
                  <iframe src="/static/pdf/admission/Information Brochure.pdf" height="600" width="100%"></iframe>
                </TabPanel>
                <TabPanel header="DSE Shceduled">
                  <iframe src="/static/pdf/admission/DSE_Scheduled_2021-22.pdf" height="600" width="100%"></iframe>
                </TabPanel>
              </TabView>
            </accordion-tab>
            <accordion-tab header="Eligibility Criteria">
              <Panel header="Maharashtra State Candidature Candidate">
                <p class="mb-2">A) The Candidate should be an Indian National. </p>
                <p class="mb-2">
                  B) Passed Diploma Course in Engineering and Technology with at least 45% marks (40% marks in case of
                  candidates of Backward class categories and Persons with Disability belonging to Maharashtra State
                  only) in appropriate branch of Engineering and Technology from an All India Council for Technical
                  Education or Central or State Government approved Institution or its equivalent.
                  <Divider align="center" type="dashed">
                    <b>OR</b>
                  </Divider>
                  Passed B.Sc. Degree from a University Grants Commission (UGC) or Association of Indian Universities
                  recognized University with at least 45% marks (40% in case of candidates of Backward class categories
                  and Persons with Disability belonging to Maharashtra State only) and passed HSC with Mathematics as a
                  subject Provided that students belonging to this category shall clear the subjects of Engineering
                  Graphics/ Engineering Drawing and Engineering Mechanics of the first year Engineering Program along
                  with second year subjects.
                </p>
              </Panel>
            </accordion-tab>
            <accordion-tab header="Documents Required">
              <div class="space-y-4">
                <Panel
                    header="For Open Category Candidates">
                  <ol class="list-decimal p-4">
                    <template v-for="(item,index) in open" :key="index">
                      <li class="ml-6">{{ item }}</li>
                    </template>
                  </ol>
                </Panel>
                <Panel
                    header="For Reserved Category Candidates">
                  <ol class="list-decimal p-4">
                    <template v-for="(item,index) in category" :key="index">
                      <li class="ml-6">{{ item }}</li>
                    </template>
                  </ol>
                </Panel>
              </div>
            </accordion-tab>
            <accordion-tab header="Admission Process">
              <Panel
                  header="For Reserved Category Candidates">
                <ol class="list-decimal p-4">
                  <template v-for="(item,index) in criteria" :key="index">
                    <li class="ml-6">{{ item }}</li>
                  </template>
                </ol>
                <a class="text-sm" href="http://www.dtemaharashtra.gov.in/index.html" target="_blank"><strong>For
                  detailed admission
                  process please visit to
                  http://www.dtemaharashtra.gov.in/index.html.</strong></a>
              </Panel>
            </accordion-tab>
          </accordion>
        </section>
        <div class="sidebar order-2">
          <div class="flex flex-col gap-3">
            <admission-contact-card v-for="(admissionContact,index) in admissionContacts" :key="index"
                                    :admissionContact="admissionContact"></admission-contact-card>
          </div>
        </div>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import KeyRecruiters from "@/components/KeyRecruiters";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import SanctionIntake from "@/views/admissions/SanctionIntake";
import AdmissionContactCard from "@/components/AdmissionContactCard";
import Divider from 'primevue/divider';
import Panel from 'primevue/panel';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

export default {
  name: "DsyUg",
  components: {
    NavbarComponent,
    PageHeader,
    FooterComponent,
    KeyRecruiters,
    Accordion,
    AccordionTab,
    SanctionIntake,
    AdmissionContactCard,
    Divider, Panel, TabView, TabPanel
  },
  data() {
    return {
      programmes: [
        {
          name: 'Computer Engineering',
          intake: '6 + Seats Remained vacant at FE',
          choiceCode: 512424510
        }, {
          name: 'Information Technology',
          intake: '6 + Seats Remained vacant at FE',
          choiceCode: 512424610
        }, {
          name: 'Civil Engineering',
          intake: '6 + Seats Remained vacant at FE',
          choiceCode: 512419110
        }, {
          name: 'Mechanical Engineering',
          intake: '18 + Seats Remained vacant at FE',
          choiceCode: 512461210
        }, {
          name: 'Electrical Engineering',
          intake: '18 + Seats Remained vacant at FE',
          choiceCode: 512429310
        },
      ],
      admissionContacts: [
        {
          name: 'Prof. Rokade P. P.',
          designation: 'Admission Coordinator',
          departments: 'IT',
          mobile: '8999049809',
          email: 'prakashrokade2005@gmail.com'
        },
        {
          name: 'Prof. Chandgude A. S.',
          designation: 'Admission Coordinator',
          departments: 'Computer',
          mobile: '9552218363',
          email: 'amarschandgude1445@gmail.com'
        },
        {
          name: 'Prof. Gujrathi T. V.',
          designation: 'Admission Coordinator',
          departments: 'Mechanical',
          mobile: '9028186643',
          email: 'tushargujrathi30592@gmail.com'
        }],
      open: [
        'Allotment Letter',
        'Final year diploma mark sheet',
        'Statement of Marks – SSC (10th)',
        'Statement of Marks – HSC (12th) (If applicable)',
        'Leaving Certificate',
        'Certificate of Indian Nationality in the name of the Candidate',
        'Domicile Certificate (if applicable), clearly indicating the place of Permanent Residence of the Candidate / Father or Mother or Husband',
        'Aadhar Card',
        'Income Certificate',
        'Gap Certificate (if applicable)',
      ],
      category: [
        'Allotment Letter',
        'Final year diploma mark sheet',
        'Statement of Marks – SSC (10th)',
        'Statement of Marks – HSC (12th) (if applicable)',
        'Leaving Certificate',
        'Certificate of Indian Nationality in the name of the Candidate',
        'Domicile Certificate (if applicable), clearly indicating the place of Permanent Residence of the Candidate / Father or Mother or Husband',
        'Aadhar Card',
        'Cast Certificate',
        'Cast Validity',
        'Non – Creamy Layer Certificate valid up to 31st March 2021 (if applicable)',
        'Gap Certificate (if applicable)',
      ],
      criteria: [
        'Publishing of information brochure by state CET cell.',
        'Filling online application form by candidate for participation in the Centralised Admission Process (CAP)',
        'Document verification at facilitation centre by the candidate.',
        'Publishing of provisional merit lists, submission of grievances, if any, and publishing of final merit list.',
        'Display of available category wise Seat Matrix for CAP Round I',
        'Filling up and confirmation of online option form having preferences of courses and institutions before CAP Round I. The option form once confirmed shall be considered for allotment in CAP Round I',
        'Display of Provisional allotment of CAP Round I indicating allotted institute and course.',
        'Reporting and confirmation of admission to the allotted institute by paying fee and submitting original documents.',
        'The students those have not confirmed the allotted seat in CAP round-I or not received any allotment in CAP round –I are eligible for further CAP rounds.',
        'Same process is applicable for CAP round II &III',
      ]
    }
  }
}
</script>

<style scoped>

</style>
